module.exports = __webpack_public_path__ + "static/media/plp.library.logo.160w.b9f73b06.png";